module.exports = __webpack_public_path__ + "img/capacitor-love.5765621e.jpg";